import { Box, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { FC, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import shallow from 'zustand/shallow';
import { useDialog } from '@/logic/state/dialog';
import { useGetDynamicPage } from '@/logic/services/dynamic-pages';
import CustomizedCircularProgress from '@/components/shared/customized-circular-progress';
import { BackwardButton } from '@/components/shared/backward-button';
import ImageBoxFuture from '@/components/shared/image-box-future';

export const HouseRules: FC = () => {
  const setDialog = useDialog(s => s.setDialog, shallow);
  const intl = useIntl();
  const { data, isLoading } = useGetDynamicPage({
    query: { type: 'HOUSE_RULE' },
  });

  const handleBackwardClick = useCallback(() => {
    setDialog(prevState => ({
      wrapper: false,
      rulesOfEntryDialogPayload: prevState?.rulesOfEntryDialogPayload,
    }));
    setTimeout(() => {
      setDialog(prevState => ({
        wrapper: true,
        isRulesOfEntryDialog: true,
        rulesOfEntryDialogPayload: prevState?.rulesOfEntryDialogPayload,
      }));
    }, 500);
  }, [setDialog]);

  return (
    <>
      <DialogTitle>
        <BackwardButton handleClick={handleBackwardClick} />
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '90%',
            margin: 'auto',
          }}
        >
          <Typography
            component='div'
            variant='h4'
            sx={{ textAlign: 'center', mt: '26px', fontWeight: 700 }}
          >
            <FormattedMessage id='booking.house_rules' />
          </Typography>{' '}
          <Box sx={{ width: 96, height: 96, marginBlock: 4, position: 'relative' }}>
            {data?.photoUrl && (
              <ImageBoxFuture
                img={data?.photoUrl}
                title={intl.formatMessage({
                  id: 'booking.house_rules',
                })}
                objectFit='cover'
                sx={{
                  width: '96px',
                  height: '96px',
                }}
              />
            )}
          </Box>
        </Box>
        <Box sx={{ marginBlockEnd: 5 }}>
          <Typography
            component='div'
            dangerouslySetInnerHTML={{ __html: data?.content as string }}
          ></Typography>
        </Box>
        <Box>
          {isLoading && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: 'auto',
                marginBlock: 3,
              }}
            >
              <CustomizedCircularProgress size={40} thickness={4} />
            </Box>
          )}
        </Box>
      </DialogContent>
    </>
  );
};
